import { Component, OnInit } from "@angular/core";
import { KpiService } from "../../kpi/kpi.service";
import { map, find, orderBy } from "lodash";
import { GraduationPlan } from "../../shared/interfaces";
import * as Constants from "../../constants";

@Component({
  selector: "graduation-plan-configuration",
  templateUrl: "./graduation-plan-configuration.component.html",
  styleUrls: ["./graduation-plan-configuration.component.scss"],
})
export class GraduationPlanConfigurationComponent implements OnInit {
  gradPlans: Array<GraduationPlan>;
  displayedColumns = [
    { name: "Graduation Plan Name", id: "GraduationPlanName" },
    { name: "Graduation Plan ID", id: "GraduationPlanID" },
    { name: "Credits Required", id: "CreditsRequired" },
  ];
  defaultGradPlanID: string;
  noGradPlansError: string = `We could not find any graduation plan data. Graduation plan data may not yet be available for your student information system. 
                Please check <a href='${Constants.HELP_URLS.GRADUATION_CREDITS_NONSTARTER_URL}' target='_blank' class='error-link'>this list</a> to determine if your source system is supported.`;
  noSchemaError: string = `This configuration is only available if you bring grades into Schoolzilla.`;
  gradPlanDoesNotExistError: string = `That graduation plan does not exist.`;
  connectionError: string = `We are having trouble connecting. Please refresh the page or contact 
    <a href='https://illuminate.zendesk.com/hc/en-us/requests/new?ticket_form_id=21621854042395' target='_blank' class='error-link'>support</a> if the issue persists.”`;
  errorDetails: string;

  constructor(private kpiService: KpiService) {}

  ngOnInit() {
    this.kpiService.getGraduationRequirements().subscribe(
      (data: Array<GraduationPlan>) => {
        if (data && data.length > 0) {
          this.gradPlans = data;
          this.gradPlans = orderBy(
            this.gradPlans,
            ["GraduationPlanName", "GraduationPlanID"],
            ["asc", "asc"]
          );
          this.setDefaultGradPlan();
        } else {
          this.errorDetails = this.noGradPlansError;
        }
      },
      (error) => {
        console.error(error);
        if (error == 404) {
          this.errorDetails = this.noSchemaError;
        } else if (error == 500) {
          this.errorDetails = this.connectionError;
        }
      }
    );
  }

  getColumnIds() {
    return ["radioButton", ...map(this.displayedColumns, "id")];
  }

  updateDefaultGradPlan(gradPlanId: string) {
    this.errorDetails = null;
    this.kpiService.updateGraduationPlan(gradPlanId).subscribe(
      (data: Array<GraduationPlan>) => {
        this.gradPlans = data;
        this.gradPlans = orderBy(
          this.gradPlans,
          ["GraduationPlanName", "GraduationPlanID"],
          ["asc", "asc"]
        );
        this.setDefaultGradPlan();
      },
      (error) => {
        console.error(error);
        if (error == 404) {
          this.errorDetails = this.gradPlanDoesNotExistError;
        } else if (error == 500) {
          this.errorDetails = this.connectionError;
        }
      }
    );
  }

  setDefaultGradPlan() {
    let defaultGradPlan: GraduationPlan = find(this.gradPlans, [
      "IsDefaultGraduationPlan",
      true,
    ]);
    if (defaultGradPlan) {
      this.defaultGradPlanID = defaultGradPlan.GraduationPlanID;
    }
  }
}
